/**
 * 與後端 api/src/constants/defaultTierDowngradeReminderTemplates.js 文案同步
 */

export const DEFAULT_TIER_DOWNGRADE_LINE_BODY =
  '{{memberName}} 您好，您目前的 {{tierName}} 資格將於 {{settlementDate}} 結算（剩 {{daysUntilSettlement}} 天），再消費 ${{amountToKeep}} 即可保級，敬請把握！';

export const DEFAULT_TIER_DOWNGRADE_SMS_BODY =
  '{{memberName}} 您好，{{tierName}} 資格 {{settlementDate}} 結算，再消費 ${{amountToKeep}} 即可保級。';

export const DEFAULT_TIER_DOWNGRADE_EMAIL_SUBJECT = '【會員等級即將結算】保級提醒';

export const DEFAULT_TIER_DOWNGRADE_EMAIL_BODY = `{{memberName}} 您好，

您目前的會員等級 {{tierName}} 將於 {{settlementDate}} 進行年度結算（剩 {{daysUntilSettlement}} 天）。

截至目前，您本年度的累計消費尚未達到續等門檻，再消費 $ {{amountToKeep}} 即可保留 {{tierName}} 資格。

把握時間消費保級，繼續享有專屬權益！`;
